import type { JSX } from "react";
import type { App } from "../app";
import type { UrlFragmentData } from "../url";
import { Alert, AlertTitle } from "@mui/material";
import { SignUpStep } from "../step";


export class ThankYouStep extends SignUpStep {
	override title: string = "Thank You";
	override view: () => JSX.Element = () => <ThankYouStepView app={ this.app }/>;
}

const getMessage = (data: UrlFragmentData, quantity: number): string => {
	const plan = data.plan?.replaceAll("_", " ");
	switch(data.type) {
		case "central":
			return `Your request to sign up as a Central Agent with ${quantity} ${plan} listing${quantity === 1 ? "" : "s"} has been received and is being reviewed by our team.`;
		case "broker":
			return `Your request to sign up to the ${plan} service as a professional Charter Broker has been received and is being reviewed by our team.`;
		default:
			return "Your request to sign up has been received and is being reviewed by our team.";
	}
};

const ThankYouStepView = (p: { app: App }) => {
	if(!p.app.data) {
		return;
	}

	return (
		<>
			<Alert severity="success">
				<AlertTitle>Thank you</AlertTitle>
				{ getMessage(p.app.data, p.app.quantity ?? 1) }
			</Alert>
		</>
	);
};
